import {formatPaymentMethod} from '@ppcp/utils';
import {
    TokenizedPaymentMethod,
    PaymentMethodDescription
} from "../../components";
import {useApplePayButton, useApplePaySession} from "./hooks";
import {useNotices, useProcessPayment, useProcessPaymentFailure} from "../../hooks";
import {i18n} from '../../utils';

export const ApplePay = (props) => {
    const {
        data,
        name,
        billing,
        onClick,
        onClose,
        cartData,
        onSubmit,
        isExpress,
        shippingData,
        emitResponse,
        checkoutStatus,
        paymentMethodId,
        eventRegistration,
        activePaymentMethod
    } = props;

    const title = data.title;

    const {
        billingAddress
    } = billing;

    const {
        shippingAddress
    } = shippingData;

    const {
        onPaymentSetup,
        onCheckoutFail
    } = eventRegistration;

    const {
        responseTypes,
        noticeContexts
    } = emitResponse;

    const extendedData = cartData?.extensions?.wc_ppcp?.cart || {};

    const {onError} = useNotices({
        onError: props.onError,
        context: noticeContexts.PAYMENTS
    });

    const {
        paymentData,
        setPaymentData,
        clearPaymentData
    } = useProcessPayment({
        name,
        title,
        onSubmit,
        responseTypes,
        onPaymentSetup,
        billingAddress,
        shippingAddress,
        paymentMethodId,
        activePaymentMethod
    });

    const {
        isReady,
        createSession
    } = useApplePaySession({
        paypal,
        billing,
        shipping: shippingData,
        onClose,
        onError,
        settings: {
            i18n,
            isExpress,
            displayName: data.displayName,
            ...extendedData
        },
        setPaymentData
    });

    const {onButtonClick} = useApplePayButton({
        onClick,
        onClose,
        onError,
        createSession
    });

    useProcessPaymentFailure({
        onError,
        isExpress,
        event: onCheckoutFail,
        responseTypes,
        messageContext: noticeContexts.PAYMENTS,
        setPaymentData,
        paymentMethodId: name,
        activePaymentMethod,
    });

    if (!isExpress && paymentData?.token) {
        const {paymentMethod} = paymentData.token;
        const card = {
            last4: paymentMethod.displayName.match(/\d{4}$/)?.[0] || paymentMethod.displayName,
            brand: paymentMethod.network.toUpperCase()
        }

        return (
            <TokenizedPaymentMethod
                alt={card.brand}
                type={card.brand.toLowerCase()}
                description={formatPaymentMethod(data.paymentFormat, card)}
                actions={[
                    {
                        type: 'cancel',
                        label: i18n.cancel,
                        onClick: clearPaymentData
                    }
                ]}
            />
        );
    }

    return (
        <>
            {!isExpress &&
                <PaymentMethodDescription description={data.description}/>
            }
            <div className={'wc-ppcp-applepay-button__container'}>
                <button
                    className={'wc-ppcp_applepay-button'}
                    style={{
                        WebkitAppearance: '-apple-pay-button',
                        ApplePayButtonType: data.button.type,
                        ApplePayButtonStyle: data.button.style,
                        borderRadius: data.button.radius,
                        height: data.button.height
                    }}
                    disabled={!isReady || checkoutStatus?.isCalculating}
                    onClick={onButtonClick}/>
            </div>
        </>
    )
}

export default ApplePay;